import React, { useEffect, useState } from 'react';
import { Button } from '@material-ui/core';

import api from '@root/api';
import useIntegration from '@root/resources/integrations/useIntegration';

import useStyles from './SuccessScreen.styles';

const SuccessScreen = ({ close }) => {
  const classes = useStyles();

  const [permissions, setPermissions] = useState('loading');
  const { data, isLoading } = useIntegration('shopify');

  useEffect(() => {
    const getPermissions = async () => {
      const { permissionsGranted } = await api.shopify.checkPermissions();
      setPermissions(permissionsGranted);
    };
    getPermissions();
  }, []);

  if (permissions === 'loading' || isLoading) {
    return (
      <div>
        Loading...
      </div>
    );
  }
  if (permissions === true) {
    return (
      <div className={classes.root}>
        <div>
          You can now generate product descriptions from
          {' '}
          <b>
            {data.data.subdomain || 'your Shopify Store'}
          </b>
          {' '}
          directly in the Copysmith application.
        </div>
        <Button
          onClick={close}
          type="button"
          className={classes.button}
        >
          Return to Copysmith
        </Button>
      </div>
    );
  }
  return (
    <div className={classes.root}>
      <div>
        There was an error connecting to your shopify store.
        <br />
        Please ensure you have granted read/write permissions.
      </div>
    </div>
  );
};

export default SuccessScreen;
